<template>
  <section id="banner">
    <div class="inner">
      <header>
        <h2>Your URLs</h2>
      </header>
      <p v-if="isProcessing"><i class="fa fa-spinner fa-spin"></i></p>
      <p v-else>
        <table>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Target</th>
          </tr>
          <tr v-for="url in urlList" :key="url.name">
            <td>
              <span class="trash-button" v-on:click="deleteUrl(url.name)">
                <i v-if="url.isProcessing" class="fa fa-spinner fa-spin"></i>
                <i v-else class="fa fa-trash"></i>
              </span>
            </td>
            <td class="cell-name"><a v-bind:href="shortUrlEndpoint + '/' + url.name">{{ url.name }}</a></td>
            <td class="cell-target"><a v-bind:href="url.target">{{ url.target }}</a></td>
          </tr>
        </table>
      </p>
    </div>
  </section>
</template>

<script>
import CloudEndpointService from '../services/cloud-endpoint'

const cloudEndpoint = new CloudEndpointService()

export default {
  name: 'ListUrls',
  data: function () {
    return {
      shortUrlEndpoint: process.env.SHORT_URL_ENDPOINT,
      isProcessing: true,
      urlList: []
    }
  },
  mounted: function () {
    let that = this
    cloudEndpoint.getUrls().then(listResult => {
      that.isProcessing = false
      that.urlList = listResult
    })
  },
  methods: {
    deleteUrl (name) {
      // Display spinner on corresponding URL
      for (let index in this.urlList) {
        if (this.urlList[index].name === name) {
          let newElement = this.urlList[index]
          newElement.isProcessing = true
          this.urlList.splice(index, 1, newElement)
        }
      }
      // Delete item and reload list
      let that = this
      cloudEndpoint.deleteUrl(name).then(result => {
        if (result) {
          cloudEndpoint.getUrls().then(listResult => {
            that.isProcessing = false
            that.urlList = listResult
          })
        }
      })
    }
  }
}
</script>

<style scoped>
th {
  font-weight: bold;
}
th, td {
  padding: 10px;
}
a {
  font-variant: normal;
  text-transform: none;
}
.cell-name {
  text-align: center;
}
.cell-target {
  text-align: left;
}
.trash-button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ListUrls.vue